import React from 'react'

type Props = {
  totalRecipes: number
  totalRecommendable: number
  totalRecommended: number
}

const RecipeDashboard = ({ totalRecipes, totalRecommendable, totalRecommended }: Props) => {
  const containerStyle: React.CSSProperties = {
    display: 'flex',
    borderRadius: '10px',
    padding: '20px 0',
    width: '100%',
    boxSizing: 'border-box',
    gap: '20px',
  }

  const cardStyle: React.CSSProperties = {
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'space-between',
    alignItems: 'start',
    backgroundColor: 'white',
    borderRadius: '10px',
    boxShadow: '0 2px 5px rgba(0, 0, 0, 0.1)',
    padding: '10px',
    width: '150px',
    textAlign: 'center',
    flexBasis: '180px',
  }

  const numberStyle: React.CSSProperties = {
    fontSize: '2rem',
    fontWeight: 'bold',
    margin: '10px 0',
    alignSelf: 'end',
    paddingRight: '10px',
  }

  const titleStyle: React.CSSProperties = {
    fontSize: '1rem',
    fontWeight: 'normal',
    color: '#555',
    textAlign: 'start',
  }

  return (
    <div style={containerStyle}>
      <div style={cardStyle}>
        <div style={titleStyle}>Total Recipes</div>
        <div style={numberStyle}>{totalRecipes}</div>
      </div>
      <div style={cardStyle}>
        <div style={titleStyle}>Recommendable Recipes</div>
        <div style={numberStyle}>{totalRecommendable}</div>
      </div>
      <div style={cardStyle}>
        <div style={titleStyle}>Recommended Recipes</div>
        <div style={numberStyle}>{totalRecommended}</div>
      </div>
      <div style={cardStyle}>
        <div style={titleStyle}>Non-recommended Recipes</div>
        <div style={numberStyle}>{totalRecommendable - totalRecommended}</div>
      </div>
    </div>
  )
}

export default RecipeDashboard
